import { useState, useEffect } from 'react';
import { getStore } from './store';
import type { Review } from '@/types/db';

export type { Review };

export function getReviews(): Review[] {
  return getStore().reviews;
}

export function useReviews(): Review[] {
  const [reviews, setReviews] = useState<Review[]>(getReviews);

  useEffect(() => {
    const handleUpdate = () => setReviews([...getReviews()]);
    handleUpdate(); // sync once after mount in case store hydrated late
    window.addEventListener('admin-content-updated', handleUpdate);
    window.addEventListener('admin-data-updated', handleUpdate);
    return () => {
      window.removeEventListener('admin-content-updated', handleUpdate);
      window.removeEventListener('admin-data-updated', handleUpdate);
    };
  }, []);

  return reviews;
}

export function getVisibleReviews(): Review[] {
  return getReviews().filter((r) => r.visible);
}
